(function () {
  /**
   * @ngdoc service/provider
   * @name jilResellerCustomers
   * @description defines service to manage jil reseller customers resources
   */
  angular.module('app.core.api.jil').provider('jilResellerCustomers', provider);

  let orgUrl, url;

  /* @ngInject */
  function provider() {
    this.configure = configure;
    this.$get = $get;

    ////////////

    function configure(config) {
      url = `${config.url}/v2/resellers`;
      orgUrl = `${config.url}/v2/organizations`;
    }

    /* @ngInject */
    function $get($resource, csvUtils) {
      const service = {
        anyCustomers: getAnyCustomersResource(),
        customer3yc: getCustomer3ycResource(),
        customerDetails: getCustomerDetailsResource(),
        customerInvitations: getCustomerInvitationsResource(),
        customerOrganizationDetails: getCustomerOrganizationDetails(),
        customerPurchases: getCustomerPurchasesResource(),
        customerQuote: getCustomerQuoteResource(),
        customers: getCustomersResource(),
        customersOrderHistory: getCustomersOrderHistory(),
        customersPASalesAQO: getCustomersPASalesAQO(),
        segmentDownload: getSegmentDownloadResource(),
        segments: getSegmentsResource(),
      };

      return service;

      ///////////

      function getAnyCustomersResource() {
        return $resource(`${url}/any/customers`, {
          resellerId: '@resellerId',
        });
      }

      function getCustomer3ycResource() {
        return $resource(
          `${url}/:resellerId/customers/customer/:customerId/3yc`,
          {
            customerId: '@customerId',
            resellerId: '@resellerId',
          },
          {
            update: {
              method: 'PUT',
            },
          }
        );
      }

      function getCustomerDetailsResource() {
        return $resource(`${url}/:resellerId/customers/customer/:customerId/details`, {
          customerId: '@customerId',
          resellerId: '@resellerId',
        });
      }

      function getCustomerInvitationsResource() {
        return $resource(
          `${url}/:resellerId/customers/customer/:customerId/invitation`,
          {
            customerId: '@customerId',
            resellerId: '@resellerId',
          },
          {
            update: {
              method: 'PUT',
            },
          }
        );
      }

      function getCustomerPurchasesResource() {
        return $resource(
          `${url}/:resellerId/customers/customer/:customerId/purchases/:purchaseId`,
          {
            customerId: '@customerId',
            purchaseId: '@purchaseId',
            resellerId: '@resellerId',
          }
        );
      }

      function getCustomerQuoteResource() {
        return $resource(
          `${url}/:resellerId/customers/customer/:customerId/quote`,
          {
            customerId: '@customerId',
            resellerId: '@resellerId',
          },
          {
            get: {
              isArray: true,
              method: 'GET',
            },
          }
        );
      }

      function getCustomersResource() {
        return $resource(
          `${url}/:resellerId/customers/customer/:customerId`,
          {
            customerId: '@customerId',
            resellerId: '@resellerId',
          },
          {
            update: {
              method: 'PUT',
            },
          }
        );
      }

      function getCustomersOrderHistory() {
        return $resource(
          `${url}/:resellerId/customers/customer/:customerId/orders`,
          {
            customerId: '@customerId',
            resellerId: '@resellerId',
          },
          {
            get: {
              isArray: true,
              method: 'GET',
            },
          }
        );
      }

      function getCustomersPASalesAQO() {
        return $resource(
          `${url}/:resellerId/customers/customer/:customerId/orders?sale_aqo_ids=:saqoIds`,
          {
            customerId: '@customerId',
            resellerId: '@resellerId',
            saqoIds: '@saleAqoIds',
          },
          {
            get: {
              isArray: true,
              method: 'GET',
            },
          }
        );
      }

      function getCustomerOrganizationDetails() {
        return $resource(
          `${orgUrl}/:customerId`,
          {
            customerId: '@customerId',
          },
          {
            get: {
              method: 'GET',
            },
          }
        );
      }

      function getSegmentDownloadResource() {
        return $resource(
          `${url}/:resellerId/customers/download/:segment`,
          {
            resellerId: '@resellerId',
            segment: '@segment',
          },
          {
            export: {
              headers: {
                Accept: 'text/csv',
              },
              method: 'GET',
              transformResponse: csvUtils.tsvBlobTransformer,
            },
          }
        );
      }

      function getSegmentsResource() {
        return $resource(`${url}/:resellerId/customers/segments/:segment`, {
          resellerId: '@resellerId',
          segment: '@segment',
        });
      }
    }
  }
})();
